"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = exports.formatPhone = exports.readFileInputField = exports.checkPhone = exports.checkOTP = exports.checkDate = exports.checkSSN = exports.swapCard = exports.phone_parts = exports.check_phone = void 0;
const phone_1 = __importDefault(require("phone"));
const api_1 = __importDefault(require("./api"));
const web_ui_1 = require("@gibme/web-ui");
const moment_1 = __importDefault(require("moment"));
/**
 * Checks to verify that the phone number is a valid NANP number
 * @ignore
 * @param number
 */
const check_phone = (number) => {
    if (typeof number === 'undefined') {
        return;
    }
    const { isValid, phoneNumber } = (0, phone_1.default)(number);
    if (isValid && phoneNumber) {
        return phoneNumber.startsWith('+1') ? phoneNumber.substring(2) : phoneNumber;
    }
};
exports.check_phone = check_phone;
/**
 * Breaks a phone number up into its relevant parts (npa, nxx, xxxx)
 *
 * @param number
 */
const phone_parts = (number) => {
    const _number = (0, exports.check_phone)(number);
    if (!_number) {
        return;
    }
    const result = _number.match(/^([0-9]{3})([0-9]{3})([0-9]{4})$/);
    if (!result) {
        return;
    }
    return {
        npa: parseInt(result[1] || '0') || 0,
        nxx: parseInt(result[2] || '0') || 0,
        xxxx: result[3]
    };
};
exports.phone_parts = phone_parts;
/**
 * Swaps the main interface card from one to another and triggers a refresh
 * @param from
 * @param to
 * @param focus
 */
const swapCard = (from, to, focus) => {
    from.slideUp({
        complete: () => {
            to.trigger('refresh')
                .slideDown({
                complete: () => {
                    if (focus) {
                        focus.trigger('focus');
                    }
                }
            });
        }
    });
};
exports.swapCard = swapCard;
/**
 * Checks a SSN field to make sure the user input is "valid"
 * @param target
 */
const checkSSN = (target) => {
    const value = (target.val() || '').trim();
    if (value.length === 0) {
        return target.removeClass('is-invalid');
    }
    if (!value.match(/[0-9]{9}/)) {
        return target.addClass('is-invalid');
    }
    return target.removeClass('is-invalid');
};
exports.checkSSN = checkSSN;
/**
 * Checks a Date field to make sure the user input is "valid"
 * @param target
 */
const checkDate = (target) => {
    const value = (target.val() || '').trim();
    if (value.length === 0) {
        return target.addClass('is-invalid');
    }
    const date = moment_1.default.utc(value);
    if (date.isBefore('1899-12-31')) {
        return target.addClass('is-invalid');
    }
    return target.removeClass('is-invalid');
};
exports.checkDate = checkDate;
/**
 * Checks an OTP field to make sure that the user input is "valid"
 * @param target
 */
const checkOTP = (target) => {
    const value = (target.val() || '').trim();
    if (value.length === 0) {
        return target.removeClass('is-invalid');
    }
    if (!value.match(/[0-9]{6}/)) {
        return target.addClass('is-invalid');
    }
    return target.removeClass('is-invalid');
};
exports.checkOTP = checkOTP;
/**
 * Checks a phone number field to make sure that the user input is "valid"
 * @param target
 */
const checkPhone = (target) => {
    const value = (target.val() || '').trim();
    if (value.length === 0) {
        return target.removeClass('is-invalid');
    }
    const { isValid, phoneNumber } = (0, phone_1.default)(value);
    if (!isValid || !phoneNumber) {
        return target.addClass('is-invalid');
    }
    return target.removeClass('is-invalid')
        .val(phoneNumber.substring(2));
};
exports.checkPhone = checkPhone;
/**
 * Reads a file from a file input field and returns the file as a base64 encoded string
 * @param element
 * @param idx
 */
const readFileInputField = (element, idx = 0) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const file = element.prop('files')[idx];
        if (!file) {
            throw new Error('Could not read input field');
        }
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            if (reader.result instanceof ArrayBuffer) {
                return resolve([Buffer.from(reader.result).toString('base64'), file.name, file.size]);
            }
            else if (reader.result === 'string') {
                return resolve([Buffer.from(reader.result).toString('base64'), file.name, file.size]);
            }
            return reject(new Error('Could not read file from input field'));
        });
        reader.readAsArrayBuffer(file);
    });
});
exports.readFileInputField = readFileInputField;
/**
 * Formats a US phone number for display
 *
 * @param phone
 */
const formatPhone = (phone) => {
    const result = (0, exports.phone_parts)(phone);
    if (!result) {
        return phone;
    }
    return `(${result.npa}) ${result.nxx}-${result.xxxx}`;
};
exports.formatPhone = formatPhone;
const logout = () => __awaiter(void 0, void 0, void 0, function* () {
    yield api_1.default.logout();
    web_ui_1.ModalHelper.close();
    (0, exports.swapCard)((0, web_ui_1.$)('#client-portal-card, #staff-login-card, #staff-portal-card'), (0, web_ui_1.$)('#client-login-card'));
});
exports.logout = logout;
